module.exports = __webpack_public_path__ + "static/media/24-7.7a891c52.svg";